import { createMedia } from '@artsy/fresnel';
import { breakpoints } from '@uds/theme-utils';
import { Transition } from 'react-transition-group';
import { useRef, useEffect } from 'react';
import { u as useContext, K as KnowledgeType, S as Smirk, E as Erk, D as DURATION_IN, a as DURATION_OUT_RELAXED, b as DURATION_OUT_PENDING, c as EXPIRE_PENDING, d as EXPIRE_RELAXED } from './index-7279b5af.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import './reactiveknowledge.stylesheet_1bs59bs.css';
import '@uds/typography';
import 'linaria';
import './erk.stylesheet_12x39tw.css';
import './action.stylesheet_mlnsdp.css';
import './smirk.stylesheet_1g3izz6.css';
import 'shortid';

const useExpire = () => useContext().expire;
var useExpire$1 = useExpire;

const PureKnowledge = props => {
  const isSmirk = props.type === KnowledgeType.SMIRK;
  if (isSmirk) {
    return /*#__PURE__*/jsx(Smirk, {
      ...props,
      children: props.message
    });
  }
  return /*#__PURE__*/jsx(Erk, {
    ...props,
    children: props.message
  });
};
const ConnectedKnowledge = _ref => {
  let {
    onExpire,
    ...rest
  } = _ref;
  const nowRef = useRef(performance.now());
  const {
    expire: delay,
    id = '',
    durationOut
  } = rest;
  useEffect(() => {
    // we don't want to reset the timer every time anything changes
    // so we need to track how much time was left the last time we called setTimeout...
    const now = performance.now();
    const diff = now - nowRef.current;
    nowRef.current = now;
    const handle = setTimeout(() => {
      onExpire(id, durationOut);
    }, delay - diff);
    return () => clearTimeout(handle);
  }, [delay, onExpire, id, durationOut]);
  return /*#__PURE__*/jsx(PureKnowledge, {
    ...rest
  });
};
var Knowledge = ConnectedKnowledge;

var useStylesheet = (_ref => {
  let {
    durationIn,
    durationOut,
    isMinSm
  } = _ref;
  return {
    styles: {
      base: {
        opacity: 0,
        marginBottom: isMinSm ? 30 : 0,
        transform: 'translateY(30px)'
      },
      entering: {
        transitionProperty: 'transform, opacity',
        transitionDuration: `${durationIn}ms, ${durationIn}ms`,
        transitionDelay: '0s, 0s',
        transitionTimingFunction: 'ease-in-out, ease-in-out',
        opacity: 1,
        transform: 'translateY(0px)'
      },
      entered: {
        transitionProperty: 'transform, opacity',
        transitionDuration: `${durationIn}ms, ${durationIn}ms`,
        transitionTimingFunction: 'ease-in-out, ease-in-out',
        transitionDelay: `${durationOut}ms, ${durationOut}ms`,
        opacity: 1,
        transform: 'translateY(0px)'
      },
      exiting: {
        transitionProperty: 'opacity',
        transitionTimingFunction: 'ease-in-out',
        transitionDuration: `${durationOut}ms`,
        transitionDelay: '0ms',
        opacity: 0,
        transform: 'translateY(0px)'
      },
      exited: {},
      unmounted: {}
    }
  };
});

const Queue = _ref => {
  let {
    knowledge,
    durationOutRelaxed,
    durationIn,
    compact,
    durationOutPending,
    onExpire,
    hasPending,
    isMinSm = false,
    expirePending,
    expireRelaxed
  } = _ref;
  const expire = hasPending ? expirePending : expireRelaxed;
  const durationOut = hasPending ? durationOutPending : durationOutRelaxed;
  const {
    styles
  } = useStylesheet({
    durationIn,
    durationOut,
    isMinSm
  });
  return /*#__PURE__*/jsx(Transition, {
    in: knowledge != null && !(knowledge !== null && knowledge !== void 0 && knowledge.expired),
    timeout: {
      appear: durationIn,
      exit: durationOut
    },
    children: state => /*#__PURE__*/jsx("div", {
      style: {
        ...styles.base,
        ...styles[state]
      },
      children: /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(Knowledge, {
          compact: compact,
          onExpire: onExpire,
          durationOut: durationOut,
          expire: expire,
          ...knowledge
        })
      }, knowledge === null || knowledge === void 0 ? void 0 : knowledge.id)
    })
  }, "transitionQueue");
};
Queue.displayName = 'Queue';
var Queue$1 = Queue;

const rkWrapper = "r1qyyrcx";
const smirkWrapper = "s10um0xn";
const erkWrapper = "edyhc2i";
const classNames = {
  rkWrapper,
  smirkWrapper,
  erkWrapper
};

const hasPending = list => list.length > 1;
const DesktopManager = _ref => {
  let {
    queue,
    timings,
    onExpire
  } = _ref;
  const smirkQueue = queue.filter(item => item.type === KnowledgeType.SMIRK);
  const erkQueue = queue.filter(item => item.type === KnowledgeType.ERK);
  const hasSmirkPending = hasPending(smirkQueue);
  const hasErkPending = hasPending(erkQueue);
  const smirk = smirkQueue[0];
  const erk = erkQueue[0];
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx("div", {
      className: classNames.smirkWrapper,
      children: /*#__PURE__*/jsx(Queue$1, {
        isMinSm: true,
        compact: true,
        knowledge: smirk,
        hasPending: hasSmirkPending,
        onExpire: onExpire,
        ...timings
      })
    }), /*#__PURE__*/jsx("div", {
      className: classNames.erkWrapper,
      children: /*#__PURE__*/jsx(Queue$1, {
        isMinSm: true,
        compact: true,
        knowledge: erk,
        hasPending: hasErkPending,
        onExpire: onExpire,
        ...timings
      })
    })]
  });
};
DesktopManager.displayName = 'DesktopManager';
var DesktopManager$1 = DesktopManager;

const MobileManager = _ref => {
  let {
    timings,
    ...rest
  } = _ref;
  const hasPending = rest.queue.length > 1;
  const knowledge = rest.queue[0];
  return /*#__PURE__*/jsx("div", {
    className: classNames.rkWrapper,
    children: /*#__PURE__*/jsx(Queue$1, {
      compact: false,
      ...rest,
      ...timings,
      hasPending: hasPending,
      knowledge: knowledge
    })
  });
};
MobileManager.displayName = 'MobileManager';
var MobileManager$1 = MobileManager;

const useQueue = () => useContext().queue;

const timings = {
  durationIn: DURATION_IN,
  durationOutRelaxed: DURATION_OUT_RELAXED,
  durationOutPending: DURATION_OUT_PENDING,
  expirePending: EXPIRE_PENDING,
  expireRelaxed: EXPIRE_RELAXED
};
const {
  MediaContextProvider,
  Media
} = createMedia({
  breakpoints: {
    xs: breakpoints.xs,
    sm: breakpoints.sm
  }
});
const ReactiveKnowledge = _ref => {
  let {
    queue,
    onExpire
  } = _ref;
  const reactiveQueue = useQueue();
  const onReactiveExpire = useExpire$1();
  const finalQueue = queue != null ? queue : reactiveQueue;
  const finalOnExpire = onExpire != null ? onExpire : onReactiveExpire;
  return (
    /*#__PURE__*/
    // @ts-ignore: error after upgrading to react 18
    jsxs(MediaContextProvider, {
      children: [/*#__PURE__*/jsx(Media, {
        at: "xs",
        children: /*#__PURE__*/jsx(MobileManager$1, {
          queue: finalQueue,
          timings: timings,
          onExpire: finalOnExpire
        })
      }), /*#__PURE__*/jsx(Media, {
        greaterThanOrEqual: "sm",
        children: /*#__PURE__*/jsx(DesktopManager$1, {
          queue: finalQueue,
          timings: timings,
          onExpire: finalOnExpire
        })
      })]
    })
  );
};
ReactiveKnowledge.displayName = 'ReactiveKnowledge';

export { ReactiveKnowledge as default, timings };
